import { ApiResponseError } from '../ApiResponseError';
import { FinApiVerificationAttempt } from './model/FinApiVerificationAttempt';
import { FinApiVerificationRedirectionUrl } from './model/FinApiVerificationRedirectionUrl';

export const postFinApiVerificationAttempt = async (
  verificationAttempt: FinApiVerificationAttempt,
): Promise<FinApiVerificationRedirectionUrl> => {
  const options: RequestInit = {
    method: 'POST',
    headers: {
      Accept: 'application/json; charset=utf-8',
      'Content-Type': 'application/json; charset=UTF-8',
    },
    body: JSON.stringify(verificationAttempt),
    credentials: 'include',
  };
  const response = await fetch(`${process.env.FIN_API_SERVICE_BASE_URL}/api/verification-attempt`, options);
  if (!response.ok) {
    throw new ApiResponseError(response.status, response);
  }
  return (await response.json()) as FinApiVerificationRedirectionUrl;
};
